const initialState = {
  payment_sources: [],
  email: '',
  errors: [],
  ui:{
    show: false,
    is_submitting: false,
  }
}

export default function paymentSources(state=initialState, action){
  switch(action.type){
    case "BEGIN_SUBMIT_UPDATE_EMAIL":
      return{
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        }
      }
    case "SUCCESS_SUBMIT_UPDATE_EMAIL":
      return{
        ...state,
        ui: {
          ...state.ui,
          is_submitting: false,
          show: false,
        }
      }
    case "FAILED_SUBMIT_UPDATE_EMAIL":
      return{
        ...state,
        ui: {
          ...state.ui,
          is_submitting: false,
        },
        errors: action.payload
      }
    case "UPDATE_PAYMENT_SOURCE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "CLEAR_PAYMENT_SOURCES_ERRORS":
      return {
        ...state,
        errors: []
      }
    case "ADD_PAYMENT_SOURCE":
      return {
        ...state,
        payment_sources: [
          action.payload,
          ...state.payment_sources,
        ]
      }
    case "REMOVE_PAYMENT_SOURCE":
      return {
        ...state,
        payment_sources: state.payment_sources.filter(source=>source.id !== action.payload.id)
      }
    case "BEGIN_DESTROY_PAYMENT_SOURCE":
      return {
        ...state,
        errors: [],
      }
    case "FAILED_DESTROY_PAYMENT_SOURCE":
      return {
        ...state,
        errors: action.payload,
      }
    case "UPDATE_PAYMENT_SOURCES_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
      }
    case 'SUCCESS_FETCH_PAYMENT_SOURCES':
      return {
        ...state, 
        ...action.payload
      }
    case "RESET_PAYMENT_SOURCES_FORM":
      return initialState;
    default: 
      return state
  }
}